// Constants for mesh visualization
export const PAD = 48;
export const INNER_MARGIN_N = 0.08; // Normalized inner margin to keep nodes away from edges
